export default {
  PASSWORD_VALIDATION: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,16}$/,
  EMAIL_VALIDATION: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
};
